import React, { useState, useEffect, } from "react"
import Loading from '../../../layouts/Loading'

import "./DeletePaymentMethodComponent.scss"
import ErrorComponent from "../../../layouts/ErrorComponent"

function DeletePaymentMethodComponent({
  paymentMethodID,
  onSubmit,
  error,
  loading: parentLoading,
}) {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)
  }, [])

  if (loading || parentLoading) {
    return <div className="container settings-container text-center">
      <Loading />
    </div>
  }

  return (
    <>
      <button
        type="button"
        className="btn joystick-danger-btn"
        data-bs-toggle="modal"
        data-bs-target={"#delete-payment-method-modal-"+paymentMethodID}
      >
        Remove
      </button>
      <div
        className="modal fade delete-payment-method-modal"
        id={"delete-payment-method-modal-"+paymentMethodID}
        tabIndex="-1"
        aria-labelledby="delete-payment-method-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h3
                className="modal-title"
                id="delete-payment-method-label"
              >
                Delete Payment Method
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-center">
                <ErrorComponent error={error} classes="delete-payment-method-error" />
              </div>
              <div className="text-center">
                Are you sure you want to delete your payment method?
              </div>
              <div className="align-items-center justify-content-center delete-payment-method-btn-container">
                <button
                  className="btn joystick-success"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <div className="delete-payment-method-space"></div>
                <button
                  className="btn joystick-btn"
                  onClick={() => onSubmit(paymentMethodID)}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DeletePaymentMethodComponent
